<template>
  <div>
    <template v-if="showOnly">
      <template v-if="currentOperator === 'in'">
        <ul>
          <li
            v-for="val in value"
          >
            {{ val }}
          </li>
        </ul>
      </template>
      <template v-else>
        {{ value }}
      </template>
    </template>
    <template v-else>
      <div v-if="!(currentOperator === 'in')">
        <input
          :value="value"
          :class="{ 'form-control': styled }"
          type="text"
          :placeholder="placeholder"
          @input="updateValue"
        >
        <template v-if="currentOperator === 'like'">
          <a
            tabindex="0"
            role="button"
            type="button"
            class="fa fa-question-circle"
            data-toggle="toggle"
            data-placement="top"
            :data-title="trans('filters.like_title')"
            :data-content="trans('filters.like_explanation')"
            data-trigger="focus"
          />
        </template>
      </div>
      <div
        v-if="currentOperator === 'in'"
        class="input-group row"
      >
        <div
          v-for="(selected, index) in selectedOptions"
          @input="updateInValue"
        >
          <div class="input-group">
            <input
              v-model="selectedOptions[index]"
              :class="{ 'form-control':styled }"
              type="text"
              style="width:80%"
            >
            <span
              class="input-group-btn"
              style="width:20%"
            >
              <button
                type="button"
                style="margin-top:0px; width:100%"
                class="btn btn-default"
                @click="removeOption(index)"
              ><span
                class="fa fa-minus"
              /></button>
            </span>
          </div>
        </div>

        <div class="row">
          <div
            class="col-xs-12"
          >
            <button
              type="button"
              class="btn btn-extra-emph pull-right"
              @click="addOption"
            >
              {{ trans('filters.add_in_option')
              }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import 'bootstrap/js/tooltip'
import 'bootstrap/js/popover'

export default {
  name: 'QueryDefault',

  props: {
    value: {
      required: false,
    },

    placeholder: {
      required: true,
    },

    styled: {
      required: true,
      type: Boolean,
    },

    operator: {
      required: true,
    },
    showOnly: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      currentOperator: this.operator,
      selectedOptions: [],
    }
  },

  watch: {
    operator: function (event) {
      if (this.currentOperator === 'in' && event !== 'in') {
        // stop using the in operator :(
        this.selectedOptions = []
        this.$emit('input', '')
      } else if (event === 'in' && this.currentOperator !== 'in') {
        // Using the in-operator!
        this.selectedOptions = ['']

        this.$emit('input', this.selectedOptions)
      }

      this.currentOperator = event
    },
  },

  mounted () {
    // Enable tooltips (used when the like-op is selected)

    $('[data-toggle="popover"]').popover()

    // if we start with an array, read it.
    if (this.operator === 'in') {
      for (let val in this.value) {
        this.selectedOptions.push(this.value[val].query)
      }
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },

    updateInValue (event) {
      this.$emit('input', this.selectedOptions)
    },

    addOption () {
      this.selectedOptions.push('')
      this.$emit('input', this.selectedOptions)
    },

    removeOption (index) {
      this.selectedOptions.splice(index, 1)
      this.$emit('input', this.selectedOptions)
    },

  },
}
</script>

<style scoped>
    .range-input, input, .result-display {
        width: auto;
        display: inline-block;
        vertical-align: middle;
    }

    .in_component{
      max-height: 200px;
    }

    input {
        width: 300px;
        max-width: 100% !important;
        margin: 0 15px;
    }
</style>
